import script from "./StatsBand.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsBand.vue?vue&type=script&setup=true&lang=js"

import "./StatsBand.vue?vue&type=style&index=0&id=efca845c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efca845c"]])

export default __exports__